import { resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BreadCrumb = _resolveComponent("BreadCrumb")!
  const _component_RecentFiles = _resolveComponent("RecentFiles")!
  const _component_DocumentsFiles = _resolveComponent("DocumentsFiles")!
  const _component_AssetsFiles = _resolveComponent("AssetsFiles")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_BreadCrumb, { PageTitle: "File Manager" }),
    _createVNode(_component_RecentFiles),
    _createVNode(_component_DocumentsFiles),
    _createVNode(_component_AssetsFiles)
  ], 64))
}